import React, { FC } from 'react';
import { Loader } from '../../../components';
import { useSwaps } from '../../../hooks/apollo/useSwaps';
import { SwapStatus } from '../../../types/enums';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { PageHeader } from '../../../components/SwapKiwi/PageHeader';
import { ReactComponent as MsKiwiGlassesSafe } from '../../../assets/svg/icons/ms-kiwi-glasses-safe.svg';
import { SwapList } from '../../../components/SwapKiwi/SwapList';
import { NoDataContainer } from '../../../components/SwapKiwi/NoDataContainer';

export const OpenSwaps: FC = () => {
  const { loading, data } = useSwaps([SwapStatus.PROPOSED, SwapStatus.INITIATED]);
  const history = useHistory();

  if (loading) {
    return <Loader />;
  }

  if (!loading && (!data || data?.length === 0)) {
    return <NoDataContainer color="kiwi" message1="Nothing to see here yet." hasCta description="" />;
  }

  const onSwapClick = (id: string): void => {
    history.push(Routes.RESOLVE_SWAP.replace(':id', id));
  };

  return (
    <section>
      <PageHeader
        background="kiwi"
        title="Open Swaps"
        description='<p class="text-lg text-cloud-900">Here you find all the swaps you proposed to someone or which were proposed to you. <br />The swaps have not been executed yet. You can cancel them at any time.</p>'
        link={{ label: 'Learn More', url: '/faq' }}
        sticker={MsKiwiGlassesSafe}
        stickerWidth={284}
        breadcrumbs={{
          links: [
            {
              label: 'Home',
              slug: Routes.LANDING_ROUTE,
            },
            {
              label: 'Open Swaps',
              slug: Routes.OPEN_SWAPS,
            },
          ],
        }}
        notTopBorder={false}
      />
      <SwapList notExpandable={true} swapList={data} onSwapClick={onSwapClick} />
    </section>
  );
};
